import { render, staticRenderFns } from "./FooterLayout.vue?vue&type=template&id=87372666&scoped=true"
import script from "./FooterLayout.vue?vue&type=script&lang=js"
export * from "./FooterLayout.vue?vue&type=script&lang=js"
import style0 from "./FooterLayout.vue?vue&type=style&index=0&id=87372666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87372666",
  null
  
)

export default component.exports